const DELIVERY_STATUSES = ['delivered', 'scheduled', 'not-yet'];

// One answer drives the existing API fields. Unknown remains unanswered.
export function deliverySelection(status) {
  const delivery_status = DELIVERY_STATUSES.includes(status) ? status : '';
  return {
    delivery_status,
    product_delivered: delivery_status ? delivery_status === 'delivered' : null,
    already_delivered: delivery_status === 'delivered',
  };
}
export function deliveryComplete(form) {
  const expected = deliverySelection(form.delivery_status);
  return !!expected.delivery_status && form.product_delivered === expected.product_delivered && form.already_delivered === expected.already_delivered;
}
// Keep optional values in the draft when changing an answer; send only active details.
export function deliveryPayload(form) {
  const selected = deliverySelection(form.delivery_status);
  return {
    ...selected,
    estimated_delivery_date: selected.delivery_status === 'scheduled' ? form.estimated_delivery_date : '',
    boxes_count: selected.delivery_status === 'delivered' && form.boxes_count !== 'Not delivered yet' ? form.boxes_count : '',
  };
}
